import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
} from "recharts";

import "../App.css";


// const data = [
//   { month: "Jan", burn: 10.84 },
//   { month: "Feb", burn: 10.30 },
//   { month: "Mar", burn: 9.87 },
//   { month: "Apr", burn: 9.49 },
//   { month: "May", burn: 7.98 },
// ];

const TrendCharts = ({data}) => {
  return (
    <section className="overview-analytics-card overview-analytics-card--burn">
      <div className="overview-analytics-card__header">
        <div>
          <p className="overview-analytics-card__eyebrow">Efficiency</p>
          <h3>Ads + Discount Burn</h3>
        </div>
        <span className="overview-analytics-card__unit">% of sales</span>
      </div>

      <div className="overview-analytics-card__chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 12, right: 12, left: -8, bottom: 0 }}>
          <defs>
            <linearGradient id="burnGradient" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#ef4444" />
              <stop offset="50%" stopColor="#facc15" />
              <stop offset="100%" stopColor="#22c55e" />
            </linearGradient>
          </defs>

          <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />

          <XAxis
            dataKey="period"
            padding={{ left: 25, right: 25 }}
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#64748b", fontSize: 12 }}
          />

          <YAxis
            domain={[0, 40]}
            tickCount={5}
            tickFormatter={(value) => `${Math.round(value)}%`}
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#64748b", fontSize: 12 }}
          />

          <Tooltip
            formatter={(value) => `${value}%`}
            contentStyle={{
              backgroundColor: "#0f172a",
              border: "1px solid #334155",
              borderRadius: "8px",
              color: "#fff",
            }}
          />

          {/* 8% Target Line */}
          {/* <ReferenceLine
            y={8}
            stroke="#94a3b8"
            strokeDasharray="5 5"
            label={{
              value: "8% Target",
              position: "right",
              fill: "#94a3b8",
            }}
          /> */}

          <Line
            type="monotone"
            dataKey="AdsDiscountburn"
            stroke="url(#burnGradient)"
            strokeWidth={4}
            dot={{ r: 6, fill: "#fff" }}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
      </div>
    </section>
  );
};

export default TrendCharts;
